import * as types from "../ActionTypes/countries";

export function fetchCountriesResolved(payload) {
  return {
    type: types.FETCH_COUNTRIES_RESOLVED,
    payload
  };
}
